<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <v-form 
      ref="form"
        v-model="valid"
        lazy-validation
      @submit.prevent="updateInseminatorInfo">
        <div class="registration-section">
          <div class="registration-heading mb-5">
            <h2>{{$t('inseminatorStatisticsInfo.updateInseminatorInfo')}}</h2>
            <v-spacer></v-spacer>
            <div class="registration-btn">
              <!-- <v-btn
                width="146"
                class="mr-2"
                outlined
                color="primary"
                :to="{ name: 'InseminatorList' }"
                exact
                >{{$t('cancel')}}</v-btn
              >
              <v-btn type="submit" width="146" color="primary">{{$t('submit')}}</v-btn> -->
            </div>
          </div>
          <v-card class="px-5 mt-5">
            <div class="animal-from">
              <v-row class="pa-5">
                <v-col cols="12"></v-col>
                <v-col lg="4" md="4" sm="6" xs="6">
                  <div class="form-group">
                    <div class="cell-2">
                      <label for="text">{{$t('actionListmod.inseminatorId')}} <span class="red--text">*</span></label>
                    </div>
                    <v-text-field
                      v-model="itemToAdd.inseminatorNumber"
                      placeholder="Inseminator ID"
                      outlined
                      dense
                      :rules="insemiRules.inseminatorNumber"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="6" xs="6">
                  <div class="form-group">
                    <div class="cell-2">
                      <label for="text">{{$t('dashboardS.inseminatorName')}} <span class="red--text">*</span></label>
                    </div>
                    <v-text-field
                      v-model="itemToAdd.inseminatorName"
                      :placeholder="$t('dashboardS.inseminatorName')"
                      outlined
                      dense
                       :rules="insemiRules.inseminatorName"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="6" xs="6">
                  <div class="form-group">
                    <label for="text">{{$t('actionListmod.conceptionRate')}} <span class="red--text">*</span></label>
                    <v-text-field
                      type="number"
                      v-model="itemToAdd.conceptionRate"
                      placeholder="3.33"
                      outlined
                      dense
                      :rules="insemiRules.conceptionRate"
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col lg="4" md="4" sm="6" xs="6">
                  <div class="form-group">
                    <label for="drugRegdate">{{$t('actionListmod.dateOfmeasurement')}}<span class="red--text">*</span> </label>
                    <v-menu
                      v-model="drugRegmenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="itemToAdd.dateOfMeasurement"
                          append-icon="mdi-calendar"
                          outlined
                          dense
                          placeholder="e.g XXXX"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="insemiRules.dateOfMeasurement"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="itemToAdd.dateOfMeasurement"
                        @input="drugRegmenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
          <div class="registration-btn bottom-btn">
            <v-btn
              width="146"
              class="mr-2"
              outlined
              color="primary"
              exact
              :to="{ name: 'InseminatorList' }"
              >{{$t('cancel')}}</v-btn
            >
            <v-btn width="146" type="submit" color="primary">{{$t('submit')}}</v-btn>
          </div>
        </div>
      </v-form>
    </v-container>
    <DataLostWarning
        :dialogI="dataLossWarning"
        v-if="dataLossWarning"
        @closeDialog="closeWarningMessage"
        @saveData="closeWarningMessage"  
    ></DataLostWarning>
  </div>
</template>

<script>
import Breadcrumb from "@/components/core/Breadcrumb";
import loadingMixin from "@/mixins/LoadingMixin";
// import FarmInfo from "./FarmInfo.vue";
import InsemiService from "@/_services/InsemnatorService";
import { insemiRules } from "@/validations/InsemiInfoRules.js";
export default {
  components: {
    breadcrumb: Breadcrumb,
    // FarmInfo
  },
  beforeRouteLeave(to, from, next) {
		if(this.formChanged) {
			this.promptToRoute = to;
			this.dataLossWarning = true;
			return
		}
		next();
	},
  watch: {
    itemToAdd: {
          handler() {
              this.formChanged = true;
          },
          deep: true
      },
  },
  data() {
    return {
      dataLossWarning: false,
      formChanged: false,
      promptToRoute: null,
      drugRegmenu: false,
      itemToAdd: {},
      insemiRules,
      valid: true,
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('inseminatorStatistics'),
          link: true,
          exact: true,
          disabled: false,
          to: { name: "InseminatorList" },
        },
        {
          text: this.$t('inseminatorStatisticsInfo.addInseminatorInfo'),
          disabled: true,
          href: "breadcrumbs_link_1",
        },
      ],
    };
  },
  async mounted() {
    await this.getItem();
  },
  methods: {
    closeWarningMessage(stay) {
        this.dataLossWarning = false;
        if(!stay) {
            this.formChanged = false;
            this.$router.push(this.promptToRoute)
        }
    },
    getItem() {
      this.startLoading();
      InsemiService.getSingleInseminator(this.$route.params.id)
        .then((response) => {
          console.log("res", response);
          this.itemToAdd = response.data.inseminatorStatistic;
          this.stopLoading();
          // console.log(this.animal);
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    },
    updateInseminatorInfo() {
       if (!this.$refs.form.validate()) return;
      this.startLoading();
      this.formChanged = false;
      //   this.itemToAdd.farmNumber=this.$route.params.farmId
      console.log("res", this.itemToAdd);
      InsemiService.updateInsemi(this.itemToAdd)
        .then((res) => {
          if (res.success) {
            this.$notify({
              title: this.$t('inseminatorStatisticsInfo.inseminatorInfoUpdated'),
              text: res.message,
              type: "success",
            });
            this.$router.push({name: 'SingleInsemi', params: {id: this.$route.params.id}})
          } else {
            this.$notify({
              title: this.$t('inseminatorStatisticsInfo.inseminatorInfoNotUpdated'),
              text: res.message,
              type: "error",
            });
          }
          this.stopLoading();
        })
        .catch((error) => {
          if (error.status == 422) {
            error.data.message.errors.forEach((err) => {
              console.log(err.param + " -- " + err.msg);
              this.errors[err.param] = err.msg;
            });
            console.log(this.errors);
          }
          this.stopLoading();
        });
    },
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss">
.registration-section .main-register {
  display: flex;
  justify-content: space-between;
}
.registration-heading {
  display: flex;
  align-items: center;
}
.registration-section .registration-heading h2 {
  /* color:#6A7784; */
  /* font-size: 20px; */
  font-family: Poppins-Medium;
}
.registration-section .registration-heading span {
  width: 1px;
  height: 30px;
  /* background: #6A7784; */
  margin: 0px 15px;
}
.registration-section .registration-heading p {
  /* color: #97A8B8; */
  font-size: 20px;
  font-family: Poppins-Medium;
}
.registration-btn {
  display: flex;
  align-items: center;
}
.registration-btn.bottom-btn {
  margin: 30px 22px 0px 0px;
  justify-content: flex-end;
  padding: 24px 15px;
  border-top: 1px solid #dae1ec;
  width: 100%;
}
.animal-from.margin-cell-3 {
  margin-top: 20px;
}
.animal-from {
  display: inline;
}
.animal-from label {
  display: inline-block;
  margin-bottom: 0.5rem;
  /* color: #97A8B8; */
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}
.animal-from .form-control {
  display: block;
  width: 100%;
  height: 50px;
  padding: 0.375rem 0.75rem;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background: #fff;
  border: 1px solid #c7d5e1;
  border-radius: 3px;
  color: #c7d5e1;
  font-family: pop_regular;
}
.animal-from .form-control:focus-visible,
.form-control-2:focus-visible {
  outline: none;
}
.animal-from .form-control::placeholder {
  font-size: 14px;
  color: #c7d5e1;
  font-family: pop_regular;
}
.animal-from .form-control-2 {
  display: block;
  width: 100%;
  height: 50px;
  padding: 1px 20px;
  line-height: 1.5;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background: #fff;
  border: 1px solid #c7d5e1;
  border-radius: 3px;
  background-position: calc(100% - 1.2rem) center !important;
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
  /* background-image: url(../img/drop2.png); */
  background-repeat: no-repeat;
  font-size: 14px;
  color: #c7d5e1;
  font-family: pop_regular;
}
.cell-2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cell-2 h2 {
  font-size: 14px;
  color: #70a4d3;
  font-family: Poppins-Medium;
  font-weight: 100;
}
.form-group {
  margin-top: -20px;
}
</style>
